import Account from './src';

export default Account;
